/**
 * Created by Jie Gao on 2017-12-06.
 */
import {IReelStopSpinData, ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class CreepyCarnivalTwoReelController extends SpinReelController{

    private _mask:PIXI.Sprite | PIXI.Graphics;
    constructor(reelId:number) {
        super(reelId);

        EventHandler.addEventListener(this, "SWITCH_TO_STAR_REELS", (event: GameEvent) => this.switchToStarSpin())
    }

    private switchToStarSpin(): void{
        let data = {reelSetName:"STAR_SPIN_REELSET"};
        this.setCurrentReelSet(data);
    }


    protected createReelView():PIXI.Container {
        const reelView:PIXI.Sprite = new PIXI.Sprite();

        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(-CreepyCarnivalTwoGameConfig.instance.SYMBOL_WIDTH/2, 0, CreepyCarnivalTwoGameConfig.instance.SYMBOL_WIDTH, CreepyCarnivalTwoGameConfig.instance.SYMBOL_HEIGHT);
        maskShape.endFill();

        if(this._mask != null) {
            reelView.removeChild(this._mask);
        }

        this._mask = maskShape;

        reelView.addChild(this._mask);
        reelView.mask = this._mask;
        return reelView;
    }

    protected getNearWinStopDelay(reelId:number):number {
        return CreepyCarnivalTwoGameConfig.instance.REEL_NEAR_WIN_STOP_DELAY;
    }
}